export default {
    computed: {
        userCanSeeClicks() {
            return  this.$auth.hasPermission('click') || this.$auth.hasRole('admin');
        },

        userCanSeeSSPs() {
            return  this.$auth.hasPermission('inventory-list')  || this.$auth.hasRole('admin');
        },

        userCanSeePremiumSSPs() {
            return this.$auth.hasPermission('inventory-list') || this.$auth.hasRole('admin');
        },
    },
}
